// Date-range helpers for dashboard filters. All bounds are local-time
// YYYY-MM-DD strings (the previous DashboardPage helper used toISOString, which
// shifts a day for positive-offset timezones like GMT+7 — fixed here).

export function isoDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function monthBounds(ref) {
  const y = ref.getFullYear(), m = ref.getMonth();
  return { from: isoDate(new Date(y, m, 1)), to: isoDate(new Date(y, m + 1, 0)) };
}
function quarterBounds(ref) {
  const q = Math.floor(ref.getMonth() / 3), y = ref.getFullYear();
  return { from: isoDate(new Date(y, q * 3, 1)), to: isoDate(new Date(y, q * 3 + 3, 0)) };
}
function yearBounds(ref) {
  const y = ref.getFullYear();
  return { from: `${y}-01-01`, to: `${y}-12-31` };
}

// Monday-based week containing `date`.
export function isoWeekBounds(date) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const day = d.getDay();                 // 0=Sun..6=Sat
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const monday = new Date(d.getFullYear(), d.getMonth(), d.getDate() + diffToMonday);
  const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
  return { from: isoDate(monday), to: isoDate(sunday) };
}
export function thisWeek(ref = new Date()) { return isoWeekBounds(ref); }
export function lastWeek(ref = new Date()) {
  return isoWeekBounds(new Date(ref.getFullYear(), ref.getMonth(), ref.getDate() - 7));
}

export const DATE_RANGES = {
  'this-week': () => thisWeek(),
  'last-week': () => lastWeek(),
  'this-month': () => monthBounds(new Date()),
  'this-quarter': () => quarterBounds(new Date()),
  'this-year': () => yearBounds(new Date()),
};
